export const riskData = [
  {
    p1: "2023-10-26 ",
    p2: "Admin-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "中 ",
    p7: "低 ",
    p7: "项目后发生 ",
    p9: " ",
    p10: "Sam ",
    p11: "更新 ",
    p12: "2023-10-27 ",
    p13: "OPEN ",
    p14: "2023-10-23 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-19 ",
    p2: "Admin-杰信 ",
    p3: " ",
    p4: " ",
    p5: "需求风险 ",
    p6: "高 ",
    p7: "高 ",
    p7: "即将发生 ",
    p9: " ",
    p10: "Lily ",
    p11: "更新 ",
    p12: "2023-10-26 ",
    p13: "OPEN ",
    p14: "2023-10-30 ",
    p15: "2 ",
    p16: "remark",
  },
  {
    p1: "2023-10-19 ",
    p2: "Admin-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "高 ",
    p7: "低 ",
    p7: "项目内发生 ",
    p9: " ",
    p10: "Ted ",
    p11: "更新 ",
    p12: "2023-10-26 ",
    p13: "CLOSE ",
    p14: "2023-10-23 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-102 ",
    p2: "Jade-杰信 ",
    p3: " ",
    p4: " ",
    p5: "执行风险 ",
    p6: "低 ",
    p7: "低 ",
    p7: "项目内发生 ",
    p9: " ",
    p10: "Sam ",
    p11: "更新 ",
    p12: "2023-10-16 ",
    p13: "OPEN ",
    p14: "2023-10-23 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-09 ",
    p2: "Carl-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "中",
    p7: "低 ",
    p7: "项目内发生 ",
    p9: " ",
    p10: "Salim ",
    p11: "更新 ",
    p12: "2023-10-16 ",
    p13: "OPEN ",
    p14: "2023-10-16 ",
    p15: "2 ",
    p16: "remark",
  },
  {
    p1: "2023-10-19 ",
    p2: "Carl-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "高 ",
    p7: "低 ",
    p7: "项目后发生 ",
    p9: " ",
    p10: "Ted ",
    p11: "更新 ",
    p12: "2023-10-26 ",
    p13: "CLOSE ",
    p14: "2023-10-23 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-05 ",
    p2: "Taylor-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "低 ",
    p7: "低 ",
    p7: "项目前发生 ",
    p9: " ",
    p10: "Ted ",
    p11: "更新 ",
    p12: "2023-10-12 ",
    p13: "OPEN ",
    p14: "2023-10-13 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-05",
    p2: "Flex-杰信 ",
    p3: " ",
    p4: " ",
    p5: "执行风险 ",
    p6: "高 ",
    p7: "低 ",
    p7: "项目内发生 ",
    p9: " ",
    p10: "Tina ",
    p11: "更新 ",
    p12: "2023-10-13 ",
    p13: "CLOSE ",
    p14: "2023-10-16 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-11 ",
    p2: "Admin-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "高 ",
    p7: "低 ",
    p7: "项目内发生 ",
    p9: " ",
    p10: "Ted ",
    p11: "更新 ",
    p12: "2023-10-26 ",
    p13: "CLOSE ",
    p14: "2023-10-23 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-11 ",
    p2: "Tony-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "中 ",
    p7: "低 ",
    p7: "项目后发生 ",
    p9: " ",
    p10: "Ted ",
    p11: "更新 ",
    p12: "2023-10-26 ",
    p13: "OPEN ",
    p14: "2023-10-29 ",
    p15: "5 ",
    p16: "remark",
  },
  {
    p1: "2023-10-19 ",
    p2: "Admin-杰信 ",
    p3: " ",
    p4: " ",
    p5: "管理风险 ",
    p6: "高 ",
    p7: "低 ",
    p7: "项目内发生 ",
    p9: " ",
    p10: "Ted ",
    p11: "更新 ",
    p12: "2023-10-26 ",
    p13: "CLOSE ",
    p14: "2023-10-23 ",
    p15: "5 ",
    p16: "remark",
  },
];

export const manageData = [
  {
    p1: "2023-10-01 ",
    p2: "工程师 ",
    p3: "开始 ",
    p4: "B ",
    p5: "问题描述B ",
    p6: " ",
    p7: "工艺 ",
    p7: "低",
    p9: " ",
    p10: "电镀总监 ",
    p11: "状态更新B",
    p12: "2023-10-31 ",
    p13: "OPEN ",
    p14: "2023-10-23 ",
  },
  {
    p1: "2023-10-20 ",
    p2: "生管 ",
    p3: "中期 ",
    p4: "C ",
    p5: "问题描述C ",
    p6: "原因分析C",
    p7: "工艺 ",
    p7: "低",
    p9: " ",
    p10: "工程师 ",
    p11: "状态更新C",
    p12: "2023-10-24 ",
    p13: "CLOSE",
    p14: "2023-10-26 ",
  },
  {
    p1: "2023-10-25 ",
    p2: "电镀总监 ",
    p3: "中期 ",
    p4: "A ",
    p5: "问题描述A ",
    p6: " ",
    p7: "物料 ",
    p7: "中",
    p9: " ",
    p10: "助理工程师 ",
    p11: "状态更新A",
    p12: "2023-10-26 ",
    p13: "OPEN ",
    p14: "2023-10-27 ",
  },
  {
    p1: "2023-10-26 ",
    p2: "副经理",
    p3: "中期 ",
    p4: "A1 ",
    p5: "问题描述A1 ",
    p6: " ",
    p7: "工艺 ",
    p7: "低",
    p9: " ",
    p10: "admin ",
    p11: "状态更新A1",
    p12: "2023-10-26 ",
    p13: "OPEN ",
    p14: "2023-10-28 ",
  },
  {
    p1: "2023-10-20 ",
    p2: "admin",
    p3: "中期 ",
    p4: "D ",
    p5: "问题描述D ",
    p6: " ",
    p7: "设计 ",
    p7: "低",
    p9: " ",
    p10: "电镀总监 ",
    p11: "状态更新D",
    p12: "2023-10-31 ",
    p13: "CLOSE ",
    p14: "2023-10-23 ",
  },
  {
    p1: "2023-10-06 ",
    p2: "工程师 ",
    p3: "开始 ",
    p4: "B ",
    p5: "问题描述B ",
    p6: " ",
    p7: "工艺 ",
    p7: "低",
    p9: " ",
    p10: "电镀总监 ",
    p11: "状态更新B",
    p12: "2023-10-31 ",
    p13: "OPEN ",
    p14: "2023-10-23 ",
  },
  {
    p1: "2023-10-08 ",
    p2: "工程师 ",
    p3: "开始 ",
    p4: "B ",
    p5: "问题描述B ",
    p6: " ",
    p7: "工艺 ",
    p7: "低",
    p9: " ",
    p10: "电镀总监 ",
    p11: "状态更新B",
    p12: "2023-10-31 ",
    p13: "OPEN ",
    p14: "2023-10-23 ",
  },
  {
    p1: "2023-10-20 ",
    p2: "生管 ",
    p3: "中期 ",
    p4: "A ",
    p5: "问题描述A ",
    p6: "原因分析A",
    p7: "工艺 ",
    p7: "中",
    p9: " ",
    p10: "工程师 ",
    p11: "状态更新A",
    p12: "2023-10-22 ",
    p13: "CLOSE",
    p14: "2023-10-26 ",
  },
];

export const gloalViewData = [
  {
    p1: "产品开发 ",
    p2: "未开始",
    p3: "105",
    p4: "105 ",
    p5: "0 ",
    p6: "0",
    p7: "105 ",
    p7: "0 ",
    p9: "0 ",
    p10: "0 ",
    p11: "0",
  },
  {
    p1: "需求设计 ",
    p2: "未开始",
    p3: "105",
    p4: "105 ",
    p5: "0 ",
    p6: "0",
    p7: "105 ",
    p7: "0 ",
    p9: "0 ",
    p10: "0 ",
    p11: "0",
  },
  {
    p1: "原型图设计 ",
    p2: "未开始",
    p3: "105",
    p4: "105 ",
    p5: "0 ",
    p6: "0",
    p7: "105 ",
    p7: "0 ",
    p9: "0 ",
    p10: "0 ",
    p11: "0",
  },
  {
    p1: "产品开发 ",
    p2: "未开始",
    p3: "105",
    p4: "105 ",
    p5: "0 ",
    p6: "0",
    p7: "105 ",
    p7: "0 ",
    p9: "0 ",
    p10: "0 ",
    p11: "0",
  },
];
